import Swiper, {
  Navigation, Pagination, Lazy,
} from 'swiper/core';

// configure Swiper to use modules
Swiper.use([Navigation, Pagination, Lazy]);

class Magazine {
  constructor() {
    this.dom = {
      carousel: document.querySelector('.carousel-magazine'),
    };

    this.data = {
      swiperConfig: {
        slidesPerView: 'auto',
        spaceBetween: 20,
        grabCursor: true,
        pagination: {
          el: '.swiper-pagination',
          dynamicBullets: true,
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        // Disable preloading of all images
        preloadImages: false,
        // Enable lazy loading
        lazy: {
          checkInView: true,
          loadPrevNext: true,
        },
      },
    };

    this.components = {
      swiperInstance: null,
    };

    this.mount();
  }

  mount() {
    if (this.dom.carousel) {
      this.components.swiperInstance = new Swiper(this.dom.carousel, this.data.swiperConfig);
    }
  }
}

if (document.getElementById('page-magazine')) {
  // eslint-disable-next-line no-new
  new Magazine();
}
